// import CountUp from "react-countup";
// import VisibilitySensor from "react-visibility-sensor";
// import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import Loader from "../../../Loader"; // Optional loader
// import { decodeHtml } from "../../util";

// const CounterStyleThree = () => {
//   const { page } = useSelector((state) => state.data);

//   const [htmlContent, setHtmlContent] = useState(null);
//   const [htmlContent2, setHtmlContent2] = useState(null);
//   const [htmlContent3, setHtmlContent3] = useState(null);

//   useEffect(() => {
//     if (page && page.data) {
//       const progress = page.data["progress"];
//       const whyChooseUs = page.data["why-choose-us"];
//       const serviceDesc = page.data["service-description"];

//       if (progress?.siteId === 2 && progress.htmlContent) {
//         const decodedHtml = decodeHtml(progress.htmlContent);
//         setHtmlContent(decodedHtml);
//       }

//       if (whyChooseUs?.siteId === 2 && whyChooseUs.htmlContent) {
//         setHtmlContent2(whyChooseUs.htmlContent);
//       }

//       if (serviceDesc?.siteId === 2 && serviceDesc.htmlContent) {
//         setHtmlContent3(serviceDesc.htmlContent);
//       }
//     }
//   }, [page]);

//   return (
//     <div className="rs-counter style3 modify1 pt-90 pb-80 md-pb-30">
//       {htmlContent ? (
//         <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
//       ) : (
//         <p>Loading Progress Content...</p> // or <Loader />
//       )}
//     </div>
//   );
// };

// export default CounterStyleThree;

import React, { useState } from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";

const CounterStyleThree = () => {
  const [state, setState] = useState(true);

  const counters = [
    {
      countNum: 569,
      countTitle: "Projects Complete",
      counterPrefix: "k",
    },
    {
      countNum: 356,
      countTitle: "Happy Clients",
      counterPrefix: "+",
    },
    {
      countNum: 783,
      countTitle: "Business Partners",
      counterPrefix: "+",
    },
    {
      countNum: 894,
      countTitle: "IT Consultant",
      counterPrefix: "+",
    },
  ];

  return (
    <div className="rs-counter style3 modify1 pt-90 pb-80 md-pb-30">
      <div className="container">
        <div className="counter-top-area">
          {counters && (
            <div className="row">
              {counters.map((counter, num) => (
                <div key={num} className="col-xl-3 col-lg-3 col-md-6 md-mb-50">
                  <div className="counter-list">
                    <div className="counter-text">
                      <div className="count-number">
                        <span className="rs-count">
                          <CountUp
                            start={state ? 0 : counter.countNum}
                            end={counter.countNum}
                            duration={10}
                            onEnd={() => setState(false)}
                          />
                          {({ countUpRef, start }) => (
                            <VisibilitySensor onChange={start} delayedCall>
                              <span ref={countUpRef} />
                            </VisibilitySensor>
                          )}
                        </span>
                        <span className="prefix">{counter.counterPrefix}</span>
                      </div>
                      <h3 className="title">{counter.countTitle}</h3>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default CounterStyleThree;
